/**
 * marchio.js — il nome scritto in cima al menu, e quale parte va in
 * evidenza.
 *
 * DA DOVE VIENE. Dal parametro `marchio_nome` della struttura, che il
 * server restituisce da solo (GET /api/marchio). Fino al 6/10/2026 il nome
 * era scritto qui, nel codice del menu, e un'installazione per un altro
 * cliente avrebbe avuto in cima al menu il nome di questa clinica (Alex,
 * 6/10/2026, risposta 21: il marchio nei parametri da subito, niente dati
 * della clinica nuovi nel codice).
 *
 * IL RIPIEGO E' NEUTRO. Se il parametro manca, e' vuoto o la rotta non
 * risponde, il menu scrive «Gestionale»: una parola che non e' il nome di
 * nessuno. Mai il nome di una clinica, nemmeno di questa: e' la regola dei
 * moduli firmati (services/parametri.js), e qui in piu' un nome di ripiego
 * che somigliasse a un marchio vero farebbe credere che il parametro ci
 * sia. «Gestionale» si nota, e chi lo nota va a guardare il parametro.
 *
 * LA PARTE IN EVIDENZA SI RICAVA DAL NOME, CON UNA REGOLA SOLA. Se il nome
 * finisce con DUE O PIU' LETTERE MAIUSCOLE di fila, e prima di loro c'e'
 * almeno una lettera minuscola, quelle maiuscole finali vanno in evidenza
 * (nel colore dell'interfaccia); altrimenti niente evidenza. Cosi':
 *   «EsempioHUB»   -> «Esempio» + «HUB» in evidenza
 *   «Studio ABC»   -> «Studio » + «ABC» in evidenza
 *   «Gestionale»   -> niente evidenza (non finisce con maiuscole)
 *   «ACME», «HUB»  -> niente evidenza (tutto maiuscolo: evidenziare tutto
 *                     non distingue niente)
 *   «EsempioH»     -> niente evidenza (una maiuscola sola e' l'iniziale
 *                     di una parola, non una sigla)
 * Nessun nome e' scritto nella regola: decide la forma del nome, quindi
 * vale per qualunque cliente senza un parametro in piu'. Valgono anche le
 * lettere accentate: maiuscola e' una lettera che cambia passando a
 * minuscola e resta uguale passando a maiuscola (e viceversa per la
 * minuscola), quindi cifre, spazi e segni non sono ne' l'una ne' l'altra.
 * Non un'espressione regolare con \p{Lu}: la build la traduce in
 * intervalli di caratteri per i browser vecchi, e pesava 4,5 kB in piu'
 * sul pacchetto principale (misurato il 6/10/2026).
 */

const maiuscola = (c) => c !== c.toLowerCase() && c === c.toUpperCase();
const minuscola = (c) => c !== c.toUpperCase() && c === c.toLowerCase();

export const MARCHIO_DI_RIPIEGO = 'Gestionale';

/**
 * Il nome da scrivere e le sue due parti: `corpo` (il colore del testo del
 * menu) ed `evidenza` (vuota se la regola non la trova). Da un valore che
 * non e' un testo, o vuoto dopo gli spazi, il ripiego.
 */
export function partiDelMarchio(valore) {
    const nome = (typeof valore === 'string' ? valore.trim() : '') || MARCHIO_DI_RIPIEGO;
    const lettere = [...nome];
    let inizio = lettere.length;
    while (inizio > 0 && maiuscola(lettere[inizio - 1])) inizio -= 1;
    const corpo = lettere.slice(0, inizio).join('');
    if (lettere.length - inizio >= 2 && [...corpo].some(minuscola)) {
        return { nome, corpo, evidenza: lettere.slice(inizio).join('') };
    }
    return { nome, corpo: nome, evidenza: '' };
}
